var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card-item',{attrs:{"title":_vm.contentItem.title,"icon":"icon-downloads"}},_vm._l((_vm.contentItem.items),function(item,key){return _c('div',{key:key},[(item.slug)?_c('router-link',{staticClass:"card__button",attrs:{"to":{
        name: 'AssetDetail',
        params: { pathName: item.slug }
      }}},[_vm._v(" "+_vm._s(item.title)+" "),_c('i',{staticClass:"icon-link"})]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }